import {CustomFieldTO} from 'generated/JavaTO'
import {CF} from 'module/CustomField/util/CustomField'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {useCallback, useMemo} from 'react'
import {log} from 'common/log'
import {CFValue} from 'module/CustomField/type/CFType'
import {ReactSelectProps} from 'config/react-select'

export function getMultiInputParameters(cfDef: CustomFieldTO) {
	const separator = CF.getCFAttr(cfDef, CFAttrKey.separator)?.value
	if (!separator) throw new Error("Missing parameter: cfattr key = separator")
	const maxAmount = parseInt(CF.getCFAttr(cfDef, CFAttrKey.maxAmount)?.value as string) || 10
	const disableManualSort = CF.getCFAttr(cfDef, CFAttrKey.disableManualSort)?.value === 'J'
	return {separator, maxAmount, disableManualSort}
}

export function arrayToStringValue<T extends string | number | null | undefined>(arr: T[], separator: string, maxAmount: number): string | null {
	if (!arr) return null
	if (!Array.isArray(arr)) return arr;
	arr = arr.filter(x => x || (x as number) === 0)
	if (!arr.length) return null
	if (arr.length > maxAmount) arr = arr.slice(arr.length - maxAmount)
	return arr.join(separator)
}

export function stringValueToArray(modelValue: string | number | null | undefined, separator: string): string[] {
	return ((modelValue || modelValue === 0 ? modelValue : '') + '').split(separator).filter(x => x)
}
/** @deprecated
 *  use this in onChange to correctly set array order (new value first)
 *  */
function onChangeSortableMultiSelectValueHandler<T>(
	value: T[],
	action: Parameters<NonNullable<ReactSelectProps<T, true>['onChange']>>[1]['action'],
	maxAmount: number = 10,
) {
	if (!value) value = [];
	if (action === 'select-option' && value.length > 1) {
		value = [value[value.length - 1], ...value.slice(0, Math.min(maxAmount, value.length) - 1)]
	}
	return value
}
export function useMultiValue(cfDef: CustomFieldTO, modelValue: string | number | null | undefined, setCb: (v: CFValue) => void, disabled?: boolean) {
	const multiInputParameters = useMemo(() => getMultiInputParameters(cfDef), [cfDef])
	const {separator, maxAmount} = multiInputParameters
	return {
		multiInputParameters,
		valueList: stringValueToArray(modelValue, separator),
		onChange: useCallback<((values: { value: string, label: string }[], action: { action: string }) => void)>((
			values: { value: string, label: string }[], // fix type is always array
			{action},
		) => {
			if (disabled) return;
			log.debug(values, action)
			switch (action) {
				case 'create-option':
					break;
				case 'select-option':
				case 'deselect-option':
				case 'remove-value':
					const v = arrayToStringValue(
						onChangeSortableMultiSelectValueHandler(values.map(x => x.value), action, maxAmount),
						separator,
						maxAmount,
					)
					setCb(v)
					break;
				case 'clear':
					setCb(null);
					break;
				case 'pop-value':
					break;
				default:
					log.error('unknown action')
			}
		}, [disabled, separator, maxAmount]),
	}
}